import { Provider } from '@angular/core';

import { PersonalDataUseCasesImpl } from '@app/domain/use-cases/personal-data/personal-data.use-cases';
import { PERSONAL_DATA_USE_CASES } from '@app/domain/use-cases/personal-data/personal-data.use-cases.contract';

export const personalDataUseCasesProvider: Provider = {
  provide: PERSONAL_DATA_USE_CASES,
  useClass: PersonalDataUseCasesImpl
};
